import type { Dispatch, SetStateAction } from 'react';

import { Box, Typography } from '@mui/material';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale';
import dayjs from 'dayjs';

import { useAppSelector } from '@/hooks/redux-hooks';

const rootSx = { alignItems: 'center', display: 'flex', flexDirection: 'column' };
const dateDisplaySx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-around',
  backgroundColor: '#272d48',
  width: 324,
  height: 30,
  mt: 1,
  mb: 1.5
};
const hintSx = { mb: 0.5 };
const calendarSx = { '& .MuiDateCalendar-root': { height: 330 } };

const AbsoluteSelector = ({
  comparisonDate,
  setComparisonDate,
  comparisonType,
  startPoint
}: {
  comparisonDate: Date | null;
  setComparisonDate: Dispatch<SetStateAction<Date | null>>;
  comparisonType: string;
  startPoint: number | undefined;
}) => {
  const { userConfig } = useAppSelector(state => state.userConfig);
  const dateFormat = userConfig.dateFormat.value.toUpperCase();
  const fakeToday = startPoint ? new Date(startPoint) : new Date();
  return (
    <Box sx={rootSx}>
      <Box sx={dateDisplaySx}>
        <Typography>
          {comparisonDate ? dayjs(comparisonDate).format(dateFormat) : dateFormat}
        </Typography>
      </Box>

      {comparisonType === 'absolute' && (
        <>
          <Typography sx={hintSx}>Select one of the available data points</Typography>
          <LocalizationProvider
            adapterLocale={{
              ...enUS,
              options: {
                ...enUS.options,
                weekStartsOn: 1 // 0 is Sunday, 1 is Monday
              }
            }}
            dateAdapter={AdapterDateFns}
          >
            <StaticDatePicker
              autoFocus
              disableHighlightToday
              defaultValue={fakeToday}
              maxDate={fakeToday}
              referenceDate={fakeToday}
              shouldDisableDate={date => {
                const day = date.getDay();
                return day === 0 || day === 6;
              }}
              slotProps={{
                day: { day: fakeToday },
                toolbar: { hidden: true },
                actionBar: { actions: [] }
              }}
              sx={calendarSx}
              timezone={startPoint ? 'UTC' : 'default'}
              value={comparisonDate}
              onChange={(value: Date | null) => {
                setComparisonDate(value);
              }}
            />
          </LocalizationProvider>
        </>
      )}
    </Box>
  );
};
export default AbsoluteSelector;
